import { render, staticRenderFns } from "./BankHeader.vue?vue&type=template&id=1b3522cc&scoped=true"
import script from "./BankHeader.vue?vue&type=script&lang=js"
export * from "./BankHeader.vue?vue&type=script&lang=js"
import style0 from "./BankHeader.vue?vue&type=style&index=0&id=1b3522cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3522cc",
  null
  
)

export default component.exports